import React from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import './About.css';

function About() {
  return (
    <div className="app-container">
      <Header />
      
      <nav className="main-nav">
        <div className="nav-container">
          <Link to="/" className="nav-link">Home</Link>
          <Link to="/about" className="nav-link active">About</Link>
        </div>
      </nav>
      
      <main className="main-content">
        <div className="about-container">
          <div className="about-header">
            <h1>About The Trump Presidency Tracker</h1>
            <div className="flag-icon-large"></div>
          </div>
          
          <div className="about-content">
            <section className="about-section">
              <h2>Our Mission</h2>
              <p>
                The Trump Presidency Tracker is dedicated to documenting the daily activities, 
                accomplishments, and key events of the Trump administration from Inauguration Day 
                (January 20, 2025) onwards. The aim of this site is to provide a comprehensive historical 
                record of the presidency day by day.
              </p>
            </section>
            
            <section className="about-section">
              <h2>How To Use This Site</h2>
              <ul className="feature-list">
                <li>
                  <span className="feature-icon home"></span>
                  <div className="feature-text">
                    <strong>Home Page:</strong> View the current month's calendar with each day of the presidency.
                  </div>
                </li>
                <li>
                  <span className="feature-icon calendar"></span>
                  <div className="feature-text">
                    <strong>Calendar:</strong> Select any month to see the timeline of presidential days.
                  </div>
                </li>
                <li>
                  <span className="feature-icon detail"></span>
                  <div className="feature-text">
                    <strong>Day Detail:</strong> Click on any day to see presidential activities and events.
                  </div>
                </li>
                {/* <li>
                  <span className="feature-icon contribute"></span>
                  <div className="feature-text">
                    <strong>Contribute:</strong> Add your own records of presidential activities to any day.
                  </div>
                </li> */}
              </ul>
            </section>
            
            <section className="about-section">
              <h2>Important Dates</h2>
              <div className="key-dates">
                <div className="key-date-item">
                  <div className="key-date">January 20, 2025</div>
                  <div className="key-date-desc">Inauguration Day - Beginning of the Trump Presidency</div>
                </div>
                <div className="key-date-item">
                  <div className="key-date">July 4, 2025</div>
                  <div className="key-date-desc">First Independence Day of the Trump Administration</div>
                </div>
                <div className="key-date-item">
                  <div className="key-date">January 20, 2029</div>
                  <div className="key-date-desc">Final day of the Trump's Second Term as President</div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
}

export default About;